import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  MenuItem,
  Select,
} from '@mui/material';

import { StyledTextField } from '../../../../../../../components/Inputs';

import { FormInputContainer, InputLabel } from './styles';

const FormField = React.memo(({
  label,
  value,
  onChange,
  type,
  isSelect,
  selectOptions,
  placeholder,
  disabled,
  error,
  helperText,
  required,
}) => (
  <FormInputContainer>
    <InputLabel>
      {label}
      {required && <span style={{ color: 'red' }}> *</span>}
    </InputLabel>
    {isSelect ? (
      <FormControl size="small" error={error} disabled={disabled}>
        <Select
          value={value}
          onChange={onChange}
          displayEmpty
          placeholder={placeholder}
        >
          {placeholder && (
            <MenuItem value="" disabled>
              {placeholder}
            </MenuItem>
          )}
          {selectOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : (
      <StyledTextField
        fullWidth
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        helperText={helperText}
        required={required}
        size="small"
      />
    )}
  </FormInputContainer>
));

FormField.displayName = 'FormField';

FormField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  isSelect: PropTypes.bool,
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
};

FormField.defaultProps = {
  type: 'text',
  isSelect: false,
  selectOptions: [],
  placeholder: '',
  disabled: false,
  error: false,
  helperText: '',
  required: false,
};

export default FormField;
